"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistor = exports.mainStore = exports.getState = exports.dispatch = void 0;
var _redux = require("redux");
var _RootReducer = _interopRequireDefault(require("./RootReducer"));
var _developmentOnly = require("redux-devtools-extension/developmentOnly");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reduxPersist = require("redux-persist");
var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));
var _immutable = _interopRequireDefault(require("immutable"));
var _reduxPersistTransformImmutable = _interopRequireDefault(require("redux-persist-transform-immutable"));
var persistConfig = {
  transforms: [(0, _reduxPersistTransformImmutable.default)()],
  key: "vnrc:root",
  storage: _storage.default,
  blacklist: []
};
var persistedReducer = (0, _reduxPersist.persistReducer)(persistConfig, _RootReducer.default);
var composeEnhancers = (0, _developmentOnly.composeWithDevTools)({
  trace: true,
  traceLimit: 25,
  serialize: {
    immutable: _immutable.default
  }
});
var middleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default));
var mainStore = (0, _redux.createStore)(persistedReducer, middleware);
exports.mainStore = mainStore;
var getState = function getState() {
  return mainStore.getState();
};
exports.getState = getState;
var dispatch = function dispatch(action) {
  return mainStore.dispatch(action);
};
exports.dispatch = dispatch;
var persistor = (0, _reduxPersist.persistStore)(mainStore);
exports.persistor = persistor;